import {getTransactionPricesBaseQuery} from "../actions/fetch_transaction_prices";
import {RoomsFilter, toRcnRooms} from "../constants/rcn_rooms_filter";
import {DEFAULT_ROOMS_FILTER} from "../constants/rooms_filter_options";
import {TRANSACTION_PRICES_GRAIN, TRANSACTION_PRICES_METRIC} from "../constants/transaction_prices";
import {RcnPriceStatsGrain} from "../types/IRcnPriceStats";
import {RcnPriceStatsQuery, RcnStatsTarget} from "../types/RcnPriceStatsQuery";

// How many recent months of RCN data PricesTrend fetches (2 years) - the chart clips it to BigData's range.
export const RCN_TREND_MONTHS = 24;

export const getRcnPriceStatsQuery = (
    regionId: number,
    // getPricesAvailableDate - the same anchor the hub table's quarter comes from.
    referenceDate: Date,
    rooms: RoomsFilter = DEFAULT_ROOMS_FILTER,
    limit = 1,
    grain: RcnPriceStatsQuery["grain"] = TRANSACTION_PRICES_GRAIN,
    metric: RcnPriceStatsQuery["metric"] = TRANSACTION_PRICES_METRIC
): RcnPriceStatsQuery => ({
    // Capped at the hub table's past quarter, not RCN's freshest - recent quarters keep filling in for weeks,
    // so an uncapped "latest" would silently change under a returning visitor.
    ...getTransactionPricesBaseQuery(referenceDate),
    // No lower bound: RCN returns the newest published point up to the cap, so an older point tells "too few
    // sales this quarter" apart from an empty series - no data for the region at all (e.g. Bydgoszcz).
    date_from: undefined,
    regionId,
    rooms: toRcnRooms(rooms),
    grain,
    metric,
    limit
});

// The address page omits market: the registry's own aggregate of both markets combined (computed on the raw
// transactions, not a client-side merge of two medians) is more accurate than asking each market separately - it
// even publishes periods where neither market alone clears the three-transaction floor - and it is one request
// instead of two. See rcn_price_stats_region docs, "tran_rodzaj_rynku = 'all'".

// The newest published month, no date bounds - the base of the address page's latest-point reads
// (getRcnLatestGrainQuery) and period reads (getRcnPeriodQuery). With no date bounds the query does not depend on
// "today", so the server and the browser always build the same cache key.
export const getRcnLatestQuery = (target: RcnStatsTarget, rooms: RoomsFilter, unit: RcnPriceStatsQuery["unit"]): RcnPriceStatsQuery => ({
    ...(typeof target === "number" ? {regionId: target} : {address: target}),
    grain: "month",
    rooms: toRcnRooms(rooms),
    unit,
    order: "desc",
    limit: 1
});

// A single building rarely has three sales in one month - the registry's floor for publishing a point - so the
// address page reads the newest point of every grain and keeps the one with the latest period_start (see
// resolve_rcn_latest_point). The order is the tie-break: a finer grain wins over a coarser one that starts the same day.
export const RCN_LATEST_GRAINS: readonly RcnPriceStatsGrain[] = ["month", "quarter", "year"];

// The newest published point of one grain, with no date bounds - however old it is.
export const getRcnLatestGrainQuery = (
    target: RcnStatsTarget,
    rooms: RoomsFilter,
    unit: RcnPriceStatsQuery["unit"],
    grain: RcnPriceStatsGrain
): RcnPriceStatsQuery => ({
    ...getRcnLatestQuery(target, rooms, unit),
    grain
});

// The same read pinned to one period, for the regions an address is compared with: a comparison only
// holds when both sides cover the same sales period, so the district and the city are read for the period
// (and the grain) the building's latest point comes from, not for their own latest one. The API filters on
// period_start (date_from <= period_start <= date_to), so both bounds are that period's first day.
export const getRcnPeriodQuery = (
    target: RcnStatsTarget,
    rooms: RoomsFilter,
    unit: RcnPriceStatsQuery["unit"],
    periodStart: string,
    grain: RcnPriceStatsGrain
): RcnPriceStatsQuery => ({
    ...getRcnLatestQuery(target, rooms, unit),
    grain,
    date_from: periodStart,
    date_to: periodStart
});

// The history chart charts years: the only grain in which the registry publishes every sale of a building - a
// building's sales rarely reach three in one month or quarter, while its years always do (the registry lists an
// address only with a published year).
export const RCN_HISTORY_GRAIN: RcnPriceStatsGrain = "year";

// Full published history for one rooms segment in one grain, no date bounds, so the server prefetch and the
// browser build the same cache key whenever the page is hydrated.
export const getRcnHistoryQuery = (target: RcnStatsTarget, rooms: RoomsFilter, grain: RcnPriceStatsGrain = RCN_HISTORY_GRAIN): RcnPriceStatsQuery => ({
    ...(typeof target === "number" ? {regionId: target} : {address: target}),
    grain,
    rooms: toRcnRooms(rooms),
    unit: "per_m2",
    order: "asc"
});
import {getTransactionPricesBaseQuery} from "../actions/fetch_transaction_prices";
import {RoomsFilter, toRcnRooms} from "../constants/rcn_rooms_filter";
import {DEFAULT_ROOMS_FILTER} from "../constants/rooms_filter_options";
import {TRANSACTION_PRICES_GRAIN, TRANSACTION_PRICES_METRIC} from "../constants/transaction_prices";
import {RcnPriceStatsGrain} from "../types/IRcnPriceStats";
import {RcnPriceStatsQuery, RcnStatsTarget} from "../types/RcnPriceStatsQuery";

// How many recent months of RCN data PricesTrend fetches (2 years) - the chart clips it to BigData's range.
export const RCN_TREND_MONTHS = 24;

export const getRcnPriceStatsQuery = (
    regionId: number,
    // getPricesAvailableDate - the same anchor the hub table's quarter comes from.
    referenceDate: Date,
    rooms: RoomsFilter = DEFAULT_ROOMS_FILTER,
    limit = 1,
    grain: RcnPriceStatsQuery["grain"] = TRANSACTION_PRICES_GRAIN,
    metric: RcnPriceStatsQuery["metric"] = TRANSACTION_PRICES_METRIC
): RcnPriceStatsQuery => ({
    // Capped at the hub table's past quarter, not RCN's freshest - recent quarters keep filling in for weeks,
    // so an uncapped "latest" would silently change under a returning visitor.
    ...getTransactionPricesBaseQuery(referenceDate),
    // No lower bound: RCN returns the newest published point up to the cap, so an older point tells "too few
    // sales this quarter" apart from an empty series - no data for the region at all (e.g. Bydgoszcz).
    date_from: undefined,
    regionId,
    rooms: toRcnRooms(rooms),
    grain,
    metric,
    limit
});

// The address page omits market: the registry's own aggregate of both markets combined (computed on the raw
// transactions, not a client-side merge of two medians) is more accurate than asking each market separately - it
// even publishes periods where neither market alone clears the three-transaction floor - and it is one request
// instead of two. See rcn_price_stats_region docs, "tran_rodzaj_rynku = 'all'".

// The newest published month, no date bounds - the base of the address page's latest-point reads
// (getRcnLatestGrainQuery) and period reads (getRcnPeriodQuery). With no date bounds the query does not depend on
// "today", so the server and the browser always build the same cache key.
export const getRcnLatestQuery = (target: RcnStatsTarget, rooms: RoomsFilter, unit: RcnPriceStatsQuery["unit"]): RcnPriceStatsQuery => ({
    ...(typeof target === "number" ? {regionId: target} : {address: target}),
    grain: "month",
    rooms: toRcnRooms(rooms),
    unit,
    order: "desc",
    limit: 1
});

// A single building rarely has three sales in one month - the registry's floor for publishing a point - so the
// address page reads the newest point of every grain and keeps the one with the latest period_start (see
// resolve_rcn_latest_point). The order is the tie-break: a finer grain wins over a coarser one that starts the same day.
export const RCN_LATEST_GRAINS: readonly RcnPriceStatsGrain[] = ["month", "quarter", "year"];

// The newest published point of one grain, with no date bounds - however old it is.
export const getRcnLatestGrainQuery = (
    target: RcnStatsTarget,
    rooms: RoomsFilter,
    unit: RcnPriceStatsQuery["unit"],
    grain: RcnPriceStatsGrain
): RcnPriceStatsQuery => ({
    ...getRcnLatestQuery(target, rooms, unit),
    grain
});

// The same read pinned to one period, for the regions an address is compared with: a comparison only
// holds when both sides cover the same sales period, so the district and the city are read for the period
// (and the grain) the building's latest point comes from, not for their own latest one. The API filters on
// period_start (date_from <= period_start <= date_to), so both bounds are that period's first day.
export const getRcnPeriodQuery = (
    target: RcnStatsTarget,
    rooms: RoomsFilter,
    unit: RcnPriceStatsQuery["unit"],
    periodStart: string,
    grain: RcnPriceStatsGrain
): RcnPriceStatsQuery => ({
    ...getRcnLatestQuery(target, rooms, unit),
    grain,
    date_from: periodStart,
    date_to: periodStart
});

// The history chart charts years: the only grain in which the registry publishes every sale of a building - a
// building's sales rarely reach three in one month or quarter, while its years always do (the registry lists an
// address only with a published year).
export const RCN_HISTORY_GRAIN: RcnPriceStatsGrain = "year";

// Full published history for one rooms segment in one grain, no date bounds, so the server prefetch and the
// browser build the same cache key whenever the page is hydrated.
export const getRcnHistoryQuery = (target: RcnStatsTarget, rooms: RoomsFilter, grain: RcnPriceStatsGrain = RCN_HISTORY_GRAIN): RcnPriceStatsQuery => ({
    ...(typeof target === "number" ? {regionId: target} : {address: target}),
    grain,
    rooms: toRcnRooms(rooms),
    unit: "per_m2",
    order: "asc"
});
